export const SKIN_TONES = ['Very Fair', 'Fair', 'Medium', 'Olive', 'Brown', 'Black'] as const;

export type SkinTone = (typeof SKIN_TONES)[number];